import { expectOneOf } from '../wire'
import contractJson from './contract.json'

const PORT_PROTOCOLS = ['TCP', 'UDP'] as const

/** The PlayFab probe contract (contract.json): one queue, one build, one game port. */
export interface PlayFabProbeContract {
  readonly queue: string
  readonly matchSize: number
  readonly giveUpAfterSeconds: number
  readonly regions: readonly string[]
  readonly pinnedRegionLatencyMs: number
  readonly maxRegionLatencyMs: number
  readonly gamePort: { readonly name: string; readonly containerPort: number; readonly protocol: (typeof PORT_PROTOCOLS)[number] }
  /** The build metadata key the room server reads its claim secret from (GSDK buildMetadata). */
  readonly claimSecretMetadataKey: string
  readonly build: {
    readonly namePrefix: string
    readonly imageName: string
    readonly vmSize: string
    readonly serversPerVm: number
    readonly standbyServers: number
    readonly maxServers: number
  }
}

export const PLAYFAB_PROBE_CONTRACT: PlayFabProbeContract = {
  ...contractJson,
  gamePort: { ...contractJson.gamePort, protocol: expectOneOf(contractJson.gamePort.protocol, PORT_PROTOCOLS, 'game port protocol') },
}
